<section class="amendment-changes" aria-label="Ce que l'avenant change">
  <div class="banner">
    <span><span class="key">Effet au</span> {{ effectiveDate() }}</span>
    <span><span class="key">Durée</span> {{ duration() }}</span>
    <span class="reasons">
      @for (reason of amendment().reasons; track reason.code) {
        <span class="reason">{{ reason.label }}</span>
      }
    </span>
  </div>

  @let changes = this.changes();
  @if (changes.workingTime.length > 0) {
    <h3>Temps de travail</h3>
    <table class="changes">
      <thead>
        <tr>
          <th>Champ</th>
          <th>Avant</th>
          <th>Après</th>
        </tr>
      </thead>
      <tbody>
        @for (change of changes.workingTime; track change.field) {
          <tr>
            <td>{{ change.field }}</td>
            <td class="before">{{ change.before }}</td>
            <td class="after">{{ change.after }}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (changes.schedules.length > 0) {
    <h3>Horaires</h3>
    <table class="changes">
      <thead>
        <tr>
          <th>Jour</th>
          <th>Avant</th>
          <th>Après</th>
        </tr>
      </thead>
      <tbody>
        @for (change of changes.schedules; track change.days) {
          <tr>
            <td>{{ change.days }}</td>
            <td class="before">{{ change.before }}</td>
            <td class="after">{{ change.after }}</td>
          </tr>
        }
      </tbody>
    </table>
    <p class="hint">Les jours qui ne changent pas ne sont pas montrés.</p>
  }

  @if (changes.assignment; as assignment) {
    <h3>Affectation</h3>
    <table class="changes">
      <thead>
        <tr>
          <th>Champ</th>
          <th>Avant</th>
          <th>Après</th>
        </tr>
      </thead>
      <tbody>
        @if (assignment.type; as type) {
          <tr>
            <td>Type d'affectation</td>
            <td class="before">{{ type.before }}</td>
            <td class="after">{{ type.after }}</td>
          </tr>
        }
        @if (assignment.added.length > 0 || assignment.removed.length > 0) {
          <tr>
            <td>Résidences</td>
            <td class="before">
              @for (label of assignment.kept.concat(assignment.removed); track label) {
                <div>{{ label }}</div>
              } @empty {
                <div>—</div>
              }
            </td>
            <td>
              @for (label of assignment.kept; track label) {
                <div class="kept">{{ label }}</div>
              }
              @for (label of assignment.added; track label) {
                <div class="after">+ {{ label }}</div>
              }
              @for (label of assignment.removed; track label) {
                <div class="removed">− {{ label }}</div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</section>
